import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import apiClient from '../api/client';
import Logo from '../components/Logo';
import './Login.css';

// Importar logo (se existir)
let logoImage;
try {
  logoImage = require('../assets/images/logo.png');
} catch (e) {
  // Logo não encontrado, usar o padrão
  logoImage = null;
}

/**
 * Página de Login conforme doc 05-especificacoes-de-api.md
 */

const Login = () => {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const { login, isAuthenticated, loading: authLoading } = useAuth();
  const navigate = useNavigate();

  // Redirecionar se já estiver autenticado
  useEffect(() => {
    if (!authLoading && isAuthenticated) {
      navigate('/dashboard', { replace: true });
    }
  }, [isAuthenticated, authLoading, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await apiClient.post('/login', { email, senha });
      
      // Validar resposta
      if (!response || !response.data) {
        throw new Error('Resposta inválida do servidor');
      }

      const { token, user, precisa_alterar_senha } = response.data;

      // Validar token e user
      if (!token || !user) {
        throw new Error('Token ou dados do usuário não recebidos');
      }

      console.log('Login bem-sucedido, atualizando estado...');
      
      // Atualizar estado de autenticação (incluindo flag precisa_alterar_senha)
      login(token, user, precisa_alterar_senha);
      
      // Aguardar um momento para garantir que o estado foi atualizado
      await new Promise(resolve => setTimeout(resolve, 100));
      
      // Se precisa alterar senha, redirecionar para página de alterar senha
      if (precisa_alterar_senha) {
        console.log('Usuário precisa alterar senha, redirecionando...');
        navigate('/alterar-senha?obrigatorio=true', { replace: true });
      } else {
        // Navegar para dashboard
        console.log('Navegando para dashboard...');
        navigate('/dashboard', { replace: true });
      }
    } catch (err) {
      console.error('Erro no login:', err);
      const errorMessage = err.response?.data?.error || err.message || 'Erro ao realizar login';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-logo">
          <Logo size="large" imageSrc={logoImage || undefined} />
        </div>
        <h2>Login</h2>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label>Senha</label>
            <input
              type="password"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          {error && <div className="error">{error}</div>}

          <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>

        <div className="login-footer">
          <p>Não tem uma conta? <Link to="/cadastro">Cadastre-se aqui</Link></p>
          <p><Link to="/esqueci-senha">Esqueci minha senha</Link></p>
          <div className="login-footer-links">
            <Link to="/privacidade">Política de Privacidade</Link>
            <span> | </span>
            <Link to="/termos">Termos de Serviço</Link>
          </div>
          <p className="footer-signature">Produzido by <strong>Chicão</strong></p>
        </div>
      </div>
    </div>
  );
};

export default Login;
